/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18n } from '../i18n';

export function withTranslations<T>(WrappedComponent: React.ComponentType<T>) {
  return (props: any) => {
    // props comes afterwards so the can override the default ones.
    return (
      <I18nextProvider i18n={i18n}>
        <WrappedComponent {...props} />
      </I18nextProvider>
    );
  };
}
